import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const autocompleteDefaultVariants = {
  "size": "md"
}
const autocompleteCompoundVariants = []

const autocompleteSlotNames = [
  [
    "root",
    "Autocomplete__root"
  ],
  [
    "divider",
    "Autocomplete__divider"
  ],
  [
    "popover",
    "Autocomplete__popover"
  ],
  [
    "dropdown",
    "Autocomplete__dropdown"
  ],
  [
    "items",
    "Autocomplete__items"
  ],
  [
    "toggle",
    "Autocomplete__toggle"
  ],
  [
    "singleValueComponentContainer",
    "Autocomplete__singleValueComponentContainer"
  ]
]
const autocompleteSlotFns = /* @__PURE__ */ autocompleteSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, autocompleteDefaultVariants, getSlotCompoundVariant(autocompleteCompoundVariants, slotName))])

const autocompleteFn = memo((props = {}) => {
  return Object.fromEntries(autocompleteSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const autocompleteVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...autocompleteDefaultVariants, ...compact(variants) })

export const autocomplete = /* @__PURE__ */ Object.assign(autocompleteFn, {
  __recipe__: false,
  __name__: 'autocomplete',
  raw: (props) => props,
  variantKeys: autocompleteVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, autocompleteVariantKeys)
  },
  getVariantProps
})